<script setup>
import { useSidebarStore } from '@/store/sidebar-store';
import { onMounted, onUnmounted, ref, watch } from 'vue';
import AppMenu from './AppMenu.vue';

const sidebarStore = useSidebarStore();
const windowWidth = ref(window.innerWidth);

const handleResize = () => {
    windowWidth.value = window.innerWidth;
    if (windowWidth.value < 768) {
        sidebarStore.setSidebarState(false);
    }
};

watch(windowWidth, (newWidth) => {
    if (newWidth < 768) {
        sidebarStore.setSidebarState(false); // 접힌 상태로
    } else {
        sidebarStore.setSidebarState(true); // 펼쳐진 상태 (기본값)
    }
});

onMounted(() => {
    window.addEventListener('resize', handleResize);
    // 초기 로드 시에도 화면 크기 확인
    handleResize();
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});
</script>

<template>
    <div :class="['layout-sidebar', { active: sidebarStore.isSidebarActive }]">
        <div class="top-space"></div>
        <div class="sidebar-content">
            <app-menu></app-menu>
        </div>
    </div>
</template>
